// Central SEO registry — used at RUNTIME (SeoManager) and at BUILD TIME (scripts/inject-seo.js).
// CommonJS on purpose so the Node postbuild script can require() it.
const SITE = "https://slowcafe.my";
const WA = "https://wa.me/60183628663";

const BIZ = {
    "@type": "LocalBusiness",
    "@id": `${SITE}/#business`,
    name: "Kaily F&B Visual Studio",
    url: SITE,
    telephone: "+60183628663",
    email: "kailygan.my@gmail.com",
    priceRange: "$$",
    address: { "@type": "PostalAddress", addressRegion: "Selangor", addressCountry: "MY" },
    sameAs: ["https://www.instagram.com/kaily_gan/"],
};

function service(name, desc, path, area, offerName, price) {
    return {
        "@context": "https://schema.org",
        "@type": "Service",
        name,
        description: desc,
        url: `${SITE}${path}`,
        provider: BIZ,
        areaServed: area.map((a) => ({ "@type": "Place", name: a })),
        offers: {
            "@type": "Offer",
            name: offerName,
            price: String(price),
            priceCurrency: "MYR",
            url: `${SITE}/photo-video-services`,
            availability: "https://schema.org/InStock",
        },
    };
}

function faqLd(items) {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: items.map(([q, a]) => ({
            "@type": "Question",
            name: q,
            acceptedAnswer: { "@type": "Answer", text: a },
        })),
    };
}

const FAQ_EN = [
    ["Where do you shoot?", "KL, Selangor, PJ and surrounding areas are included in the price. Outstation (Penang / JB) by quote. International work is quoted in writing in explicit currency."],
    ["How fast is delivery?", "Standard delivery is agreed in writing per project. Rush delivery is available at a surcharge."],
    ["What does it cost?", "Current packages and pricing — Social Content Reels, Product Social Video, Menu Photoshoot and Brand Campaign tiers — are listed on the services page. Every package shows its full scope before you book."],
    ["What is the payment flow?", "50% deposit confirms the date, 50% on delivery. Bank transfer, Stripe or TNG."],
    ["Who owns the content?", "You retain organic social media usage rights for the delivered content. Paid advertising, broadcast and out-of-home placements are licensed separately in writing."],
];
const FAQ_CN = [
    ["在哪里拍摄?", "吉隆坡、雪兰莪、PJ 及周边已含在价格内。槟城 / 新山另行报价。国际项目按明确币种以书面报价。"],
    ["多快交付?", "标准交付以项目书面确认为准。加急交付另议。"],
    ["价格多少?", "最新套餐与价格 — 社媒内容短视频、产品社媒视频、菜单摄影与品牌宣传套餐 — 请见服务页。每个套餐在预订前都会清楚列出完整范围。"],
    ["怎么付款?", "50% 订金锁定档期,交付时付尾款。支持银行转账 / Stripe / TNG。"],
    ["内容版权归谁?", "交付内容的自然社媒发布使用权归你。付费广告、广播及户外投放授权另行书面约定。"],
];

const ROUTES = {
    "/": {
        title: "Kaily F&B Visual Studio — Brand Films, Commercial Campaigns & Food Content · KL & Selangor",
        description: "Independent F&B visual studio in Selangor serving KL, Klang Valley and Malaysia — cinematic brand films, commercial campaigns, editorial food photography and social-ready reels for cafes, restaurants and food brands. International projects by custom quote with explicit currency.",
        alt: { en: "/", cn: "/cn" },
        locale: "en_MY",
    },
    "/cn": {
        title: "Kaily 餐饮视觉工作室 — 品牌影片 · 商业宣传 · 餐饮内容 · 吉隆坡 & 雪兰莪",
        description: "雪兰莪独立餐饮视觉工作室,服务吉隆坡与巴生谷 — 电影感品牌影片、商业宣传、美食摄影与社媒短视频。国际项目按明确币种定制报价。",
        alt: { en: "/", cn: "/cn" },
        locale: "zh_CN",
    },
    "/work": {
        title: "Case Studies & Selected Work — Kaily F&B Visual Studio",
        description: "Real F&B shoots by Kaily — cafe shop videos, food photography and social reels for Malaysian cafes and restaurants, with goals, deliverables and results.",
        alt: { en: "/work" },
        locale: "en_MY",
    },
    "/journal": {
        title: "Journal — F&B Visual Notes by Kaily",
        description: "Practical notes on food photography, cafe reels and F&B visual branding in Malaysia, written by Kaily.",
        alt: { en: "/journal" },
        locale: "en_MY",
    },
    "/photo-video-services": {
        title: "F&B Photography & Video Packages — Kaily, KL & Selangor",
        description: "Half-day F&B shoots in KL & PJ — retouched images, cinematic reels, social-ready crops, organic social usage. Current packages (Social Content Reels, Product Social Video, Menu Photoshoot, Brand Campaign) with full scope and pricing on the services page. Paid-media licensing arranged separately in writing.",
        alt: { en: "/photo-video-services", cn: "/photo-video-services/cn" },
        locale: "en_MY",
        jsonLd: [
            service("F&B Photography & Videography", "Half-day food photography and video shoots for cafes and restaurants in KL and Selangor. See services page for current packages.", "/photo-video-services", ["Kuala Lumpur", "Selangor", "Klang Valley"]),
            faqLd(FAQ_EN),
        ],
    },
    "/photo-video-services/cn": {
        title: "餐饮摄影与视频套餐 — Kaily · 吉隆坡 & 雪兰莪",
        description: "吉隆坡与 PJ 半天餐饮拍摄 — 精修图片、电影感短视频、社媒即用尺寸、包含自然社媒发布使用权。最新套餐(社媒内容短视频、产品社媒视频、菜单摄影、品牌宣传)请见服务页,完整范围与价格一次列清。付费广告授权另行书面约定。",
        alt: { en: "/photo-video-services", cn: "/photo-video-services/cn" },
        locale: "zh_CN",
        jsonLd: [
            service("餐饮摄影与视频拍摄", "吉隆坡与雪兰莪的咖啡馆与餐厅半天拍摄服务。最新套餐与价格请见服务页。", "/photo-video-services/cn", ["Kuala Lumpur", "Selangor", "Klang Valley"]),
            faqLd(FAQ_CN),
        ],
    },
    "/food-videographer-kuala-lumpur": {
        title: "Food Videographer in Kuala Lumpur — Cinematic Cafe & Restaurant Reels | Kaily",
        description: "Kaily is an independent food videographer in Kuala Lumpur & Selangor — cinematic cafe reels, shop videos and menu films, with organic social usage included. Current packages and pricing on the services page. Paid-media licensing arranged separately in writing.",
        alt: { en: "/food-videographer-kuala-lumpur", cn: "/food-videographer-kuala-lumpur/cn" },
        locale: "en_MY",
        jsonLd: [
            service("Food Videography — Kuala Lumpur", "Cinematic food and cafe videography in Kuala Lumpur: short reels, shop videos and menu films, shot and edited by Kaily.", "/food-videographer-kuala-lumpur", ["Kuala Lumpur", "Selangor"]),
            faqLd(FAQ_EN),
        ],
    },
    "/food-videographer-kuala-lumpur/cn": {
        title: "吉隆坡餐饮短视频拍摄 — 咖啡馆 Reels 与店铺视频 | Kaily",
        description: "Kaily 吉隆坡与雪兰莪独立餐饮视频摄影师 — 电影感咖啡馆 Reels、店铺视频与菜单影片,含自然社媒发布使用权。最新套餐与价格请见服务页。付费广告授权另行书面约定。",
        alt: { en: "/food-videographer-kuala-lumpur", cn: "/food-videographer-kuala-lumpur/cn" },
        locale: "zh_CN",
        jsonLd: [
            service("吉隆坡餐饮视频拍摄", "吉隆坡电影感餐饮与咖啡馆视频:短视频 Reels、店铺视频与菜单影片,由 Kaily 亲自拍摄与剪辑。", "/food-videographer-kuala-lumpur/cn", ["Kuala Lumpur", "Selangor"]),
            faqLd(FAQ_CN),
        ],
    },
    "/restaurant-opening-campaign-kl": {
        title: "Restaurant Opening Campaign in KL — Launch Photography & Video | Kaily",
        description: "Launch your restaurant or cafe in KL with a full opening campaign: launch reels, menu photography and social-ready content in one shoot. See services page for current campaign packages.",
        alt: { en: "/restaurant-opening-campaign-kl", cn: "/restaurant-opening-campaign-kl/cn" },
        locale: "en_MY",
        jsonLd: [
            service("Restaurant Opening Campaign — KL", "Opening campaign shoots for new restaurants and cafes in Kuala Lumpur: launch reel, menu photography and social content in one engagement.", "/restaurant-opening-campaign-kl", ["Kuala Lumpur", "Selangor"]),
            faqLd(FAQ_EN),
        ],
    },
    "/restaurant-opening-campaign-kl/cn": {
        title: "吉隆坡餐厅开业宣传拍摄 — 开业视频与菜单摄影 | Kaily",
        description: "吉隆坡餐厅/咖啡馆开业宣传:开业短视频、菜单摄影与社媒内容一次拍齐。最新套餐与价格请见服务页,Kaily 亲自拍摄。",
        alt: { en: "/restaurant-opening-campaign-kl", cn: "/restaurant-opening-campaign-kl/cn" },
        locale: "zh_CN",
        jsonLd: [
            service("吉隆坡餐厅开业宣传拍摄", "为吉隆坡新开餐厅与咖啡馆提供开业宣传拍摄:开业视频、菜单摄影与社媒内容。", "/restaurant-opening-campaign-kl/cn", ["Kuala Lumpur", "Selangor"]),
            faqLd(FAQ_CN),
        ],
    },
    "/food-product-video-malaysia": {
        title: "Food Product Video in Malaysia — Product Reels & Brand Films | Kaily",
        description: "Food product videos for Malaysian F&B brands — product reels, packaging shots and brand films, shot in KL & Selangor, with organic social usage included. Current packages and pricing on the services page.",
        alt: { en: "/food-product-video-malaysia", cn: "/food-product-video-malaysia/cn" },
        locale: "en_MY",
        jsonLd: [
            service("Food Product Video — Malaysia", "Product videography for food and beverage brands in Malaysia: product reels, packaging films and brand videos.", "/food-product-video-malaysia", ["Malaysia", "Kuala Lumpur", "Selangor"]),
            faqLd(FAQ_EN),
        ],
    },
    "/food-product-video-malaysia/cn": {
        title: "马来西亚食品产品视频拍摄 — 产品 Reels 与品牌影片 | Kaily",
        description: "为马来西亚餐饮品牌拍摄食品产品视频 — 产品短视频、包装镜头与品牌影片,含自然社媒发布使用权。最新套餐与价格请见服务页。付费广告授权另行书面约定。",
        alt: { en: "/food-product-video-malaysia", cn: "/food-product-video-malaysia/cn" },
        locale: "zh_CN",
        jsonLd: [
            service("马来西亚食品产品视频", "为马来西亚食品与饮料品牌提供产品视频拍摄:产品 Reels、包装影片与品牌视频。", "/food-product-video-malaysia/cn", ["Malaysia", "Kuala Lumpur", "Selangor"]),
            faqLd(FAQ_CN),
        ],
    },
    "/menu-photographer-klang-valley": {
        title: "Menu Photographer in Klang Valley — Hand-Retouched Menu Shoots | Kaily",
        description: "Menu photography for cafes and restaurants across the Klang Valley — hand-retouched, menu-ready images with social crops. Current packages and delivery timeline on the services page.",
        alt: { en: "/menu-photographer-klang-valley", cn: "/menu-photographer-klang-valley/cn" },
        locale: "en_MY",
        jsonLd: [
            service("Menu Photography — Klang Valley", "Menu photography for restaurants and cafes in the Klang Valley: retouched, menu-ready and social-ready images.", "/menu-photographer-klang-valley", ["Klang Valley", "Kuala Lumpur", "Selangor"]),
            faqLd(FAQ_EN),
        ],
    },
    "/menu-photographer-klang-valley/cn": {
        title: "巴生谷菜单摄影 — 手工精修餐厅菜单拍摄 | Kaily",
        description: "巴生谷咖啡馆与餐厅菜单摄影 — 手工精修、菜单即用图片附社媒尺寸。最新套餐与交付时间请见服务页。",
        alt: { en: "/menu-photographer-klang-valley", cn: "/menu-photographer-klang-valley/cn" },
        locale: "zh_CN",
        jsonLd: [
            service("巴生谷菜单摄影", "为巴生谷餐厅与咖啡馆提供菜单摄影:精修、菜单即用并附社媒尺寸。", "/menu-photographer-klang-valley/cn", ["Klang Valley", "Kuala Lumpur", "Selangor"]),
            faqLd(FAQ_CN),
        ],
    },
};

module.exports = { SITE, WA, ROUTES };
